<template>
  <sdPageHeader :title="$t('pages.demos.list.title')" />
  <Main>
    <sdCards>
      <a-row :gutter="16">
        <a-col :span="4">
          <label> {{ $t('pages.demos.list.title') }} </label>
          <a-select
            :placeholder="$t('common.choose')"
            style="width: 100%"
            v-model:value="filter.status"
            @change="onFilterChange"
          >
            <a-select-option :value="null">
              {{ $t('common.choose') }}
            </a-select-option>
            <a-select-option :value="1">
              {{ $t('common.1') }}
            </a-select-option>
            <a-select-option :value="0">
              {{ $t('common.0') }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="4">
          <label> &nbsp;</label>
          <SearchBoxVue v-model:text="filter.search" @text-changed="onFilterChanged()" />
        </a-col>
        <a-col :span="2">
          <label> &nbsp;</label>
          <sdButton size="default" :outlined="true" type="success" style="width: 100%" @click="getTable">
            {{ $t('common.filter') }}
          </sdButton>
        </a-col>
        <a-col :span="2">
          <label> &nbsp;</label>
          <sdButton size="default" :outlined="true" type="primary" style="width: 100%" @click="showModal()">
            {{ $t('pages.demos.list.create-demo') }}
          </sdButton>
        </a-col>
      </a-row>
      <br />

      <div v-if="isLoading" class="spin">
        <a-spin />
      </div>
      <div v-else>
        <a-table
          class="table-responsive"
          :columns="columns"
          :data-source="tableData"
          :pagination="{
            pageSize: this.filter.pageSize,
            showSizeChanger: true,
            total: this.filter.total,
            current: this.filter.current,
          }"
          @change="onTableChange"
          size="small"
        >
          <template #status="{ record }">
            <a-space align="baseline">
              <a-switch v-model:checked="record.status" @click="onToggleChange(record)" />
              <p>{{ record.status ? $t('common.1') : $t('common.0') }}</p>
            </a-space>
          </template>

          <template #action="{ record }">
            <a-space>
              <a-tooltip placement="top">
                <template #title>
                  <span>{{ $t('common.remove') }}</span>
                </template>
                <a-button type="primary" @click="deleteRecord(record.key)">
                  <template #icon> <sdFeatherIcons type="trash-2" style="color: white" /> </template>
                </a-button>
              </a-tooltip>
              <a-tooltip placement="top">
                <template #title>
                  <span>{{ $t('common.edit') }}</span>
                </template>
                <router-link :to="'/demos/detail/' + record.key">
                  <a-button type="primary">
                    <template #icon> <sdFeatherIcons type="edit" style="color: white" /> </template>
                  </a-button>
                </router-link>
              </a-tooltip>
            </a-space>
          </template>
        </a-table>
      </div>
    </sdCards>
  </Main>

  <a-modal v-model:visible="isModalVisible" :footer="null">
    <a-form layout="vertical" :model="modalForm" @submit="handleFinishModal">
      <a-form-item :label="$t('pages.demos.list.modal-label-developer')">
        <a-select :placeholder="$t('common.choose')" v-model:value="modalForm.id">
          <a-select-option :value="null">
            {{ $t('common.choose') }}
          </a-select-option>
          <a-select-option v-for="(developer, index) in developerList" :key="index" :value="developer.id">
            {{ developer.email }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('pages.demos.list.modal-label-url')">
        <a-input v-model:value="modalForm.url" :placeholder="$t('pages.demos.list.modal-url-placeholder')" required />
      </a-form-item>
      <a-form-item :label="$t('pages.demos.list.modal-label-day')">
        <a-input v-model:value="modalForm.day" type="number" :placeholder="$t('pages.demos.list.modal-day-placeholder')" required />
      </a-form-item>

      <sdButton size="default" htmlType="submit" type="primary">{{ $t('common.save') }} </sdButton>
    </a-form>
  </a-modal>
</template>

<script>
import { Main } from '@/view/styled';
import { dateToTr } from '@/utility/helper.js';
import SearchBoxVue from '@/components/search/SearchBox.vue';

export default {
  name: 'DemoList',
  components: {
    Main,
    dateToTr,
    SearchBoxVue,
  },
  data() {
    return {
      isLoading: true,
      isFilterNew: false,
      isModalVisible: false,
      developerList: [],
      filter: {
        current: 1,
        pageSize: 10,
        total: null,
        search: '',
        status: null,
      },
      modalForm: {
        id: null,
        url: '',
        day: '',
      },
      tableData: [],
      columns: [
        {
          title: this.$t('pages.demos.list.table-email'),
          dataIndex: 'email',
          key: 'email',
        },
        {
          title: this.$t('pages.demos.list.table-name'),
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: this.$t('pages.demos.list.table-surname'),
          dataIndex: 'surname',
          key: 'surname',
        },
        {
          title: this.$t('pages.demos.list.table-url'),
          dataIndex: 'demo_url',
          key: 'demo_url',
        },
        {
          title: this.$t('pages.demos.list.table-expire-date'),
          dataIndex: 'expired_at',
          key: 'expired_at',
        },
        {
          title: this.$t('pages.demos.list.table-state'),
          dataIndex: 'status',
          key: 'status',
          slots: { customRender: 'status' },
        },
        {
          title: this.$t('pages.demos.list.table-action'),
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    clearModalForm() {
      this.modalForm = {
        id: null,
        url: '',
        day: '',
      };
      this.isModalVisible = false;
    },
    handleFinishModal() {
      this.$appAxios.post(this.$endpoints.demos_create, this.modalForm).then(response => {
        if (response.data.status === true) {
            this.getTable();
            this.clearModalForm();
          this.$message.success(this.$t('common.success-message'));
        } else {
          this.$message.error(this.$t('common.error-message'));
        }
      });
    },
    showModal() {
      this.getDevelopers();
      this.isModalVisible = true;
    },
    deleteRecord(id) {
      if (!confirm(this.$t('common.confirm-delete'))) {
        return;
      }
      this.$appAxios.post(this.$endpoints.demos_delete, { id: id }).then(response => {
        if (response.data.status === true) {
          this.getTable();
          this.$message.success(this.$t('common.success-message'));
        } else {
          this.$message.error(this.$t('common.error-message'));
        }
      });
    },
    getDevelopers() {
      this.$appAxios.post(this.$endpoints.demos_developers).then(response => {
        if (response.data.status === true) {
          this.developerList = response.data.data;
        } else {
          this.$message.error(this.$t('common.error-message'));
        }
      });
    },
    onFilterChanged() {
      this.isFilterNew = true;
      this.filter.current = 1;
    },
    onToggleChange(record) {
      this.updateRecord(record);
    },
    updateRecord(record) {
      var form = {
        id: record.key,
        status: record.status ? 1 : 0,
      };
      this.$appAxios.post(this.$endpoints.demos_update, form).then(response => {
        if (response.data.status === true) {
          this.$message.success(this.$t('common.success-message'));
        } else {
          this.$message.error(this.$t('common.error-message'));
        }
      });
    },
    onTableChange(e) {
      this.filter.current = this.isFilterNew ? 1 : e.current;
      this.filter.pageSize = e.pageSize;
      this.getTable();
      this.isFilterNew = false;
    },
    getTable() {
      this.isLoading = true;
      this.$appAxios.post(this.$endpoints.demos_get_table, this.filter).then(response => {
        if (response.data.status === true) {
          var tableRecords = response.data.data.tableData;
          this.filter.total = response.data.data.total;
          this.tableData = [];
          var _this = this;
          tableRecords.forEach(function(item, index) {
            _this.tableData.push({
              key: item.id,
              email: item.email,
              demo_url: item.demo_url,
              expired_at: dateToTr(item.expired_at),
              status: item.is_active ? true : false,
              name: item.name,
              surname: item.surname,
            });
          });
        } else {
          this.$message.error(this.$t('common.error-message'));
        }
        this.isLoading = false;
      });
    },
  },
};
</script>
